import { render, staticRenderFns } from "./PageFifteenth.vue?vue&type=template&id=6c226e29&scoped=true"
import script from "./PageFifteenth.vue?vue&type=script&lang=js"
export * from "./PageFifteenth.vue?vue&type=script&lang=js"
import style0 from "./PageFifteenth.vue?vue&type=style&index=0&id=6c226e29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c226e29",
  null
  
)

export default component.exports